<template>
  <div class="message-item">
    <!-- question -->
    <div
      class="receiver"
      v-if="
        message.questiontype &&
          message.questiontype != 'comment' &&
          message.questiontype != 'noreply'
      "
    >
      <div class="user">
        <template v-if="receiver.profile_pic">
          <v-avatar :size="15" color="grey lighten-4">
            <img class="profile" :src="receiver.profile_pic" alt />
          </v-avatar>
        </template>
      </div>
      <div class="message" style="position: relative">
        <message-viewer
          v-model="parseQuestionMessage"
          :size="'small'"
          :showProfile="false"
          :align="'left'"
        ></message-viewer>
        <!-- :align="value.answerby != '' || value.answerby == 'bot' ? 'right' : 'left'" -->
        <div align="left" style="height: 0.5em">
          <small style="position: relative; bottom: 1.3em">{{
            value.timestamp | DateFormat('DD/MM/YYYY HH:mm')
          }}</small>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>

    <!-- answer -->
    <div
      class="sender"
      :class="{ bot: value.answerby == 'bot' }"
      v-if="
        (value.answerby != '' || value.answerby == 'bot') &&
          parseAnswerMessage[0] &&
          parseAnswerMessage[0].length > 0 &&
          message.messagetype != 'noreply'
      "
    >
      <div v-if="value.postid" class="text-xs-center small" style="font-size: small">
        {{ $t('This message was reply automatically.') }}
        <a :href="`https://www.facebook.com/${value.postid}`" target="_blank">
          {{ $t('Go to post') }}
        </a>
      </div>
      <div class="user">
        <v-avatar :size="15" color="grey lighten-4">
          <img
            class="profile"
            :src="'https://graph.facebook.com/' + selectedBot.pageid + '/picture'"
            alt
          />
        </v-avatar>
      </div>
      <div class="message" style="position: relative">
        <message-viewer
          v-model="parseAnswerMessage"
          :size="'small'"
          :showProfile="false"
          :align="value.answerby != '' || value.answerby == 'bot' ? 'right' : 'left'"
        ></message-viewer>
        <div align="right" style="height: 0.5em">
          <small style="position: relative; bottom: 1.3em">{{
            value.timestamp | DateFormat('DD/MM/YYYY HH:mm  -  ')
          }}</small>

          <small v-if="adminName" style="position: relative; bottom: 1.3em">{{ adminName }}</small>
          <small v-else style="position: relative; bottom: 1.3em">Bot</small>
        </div>
      </div>

      <div class="clearfix"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MessageViewer from '@/components/elements/MessageViewer'
import moment from 'moment'
import axios from 'axios'

export default {
  props: ['value', 'receiver', 'userAns'],
  data: function() {
    return {
      message: this.value,
      isError: false
    }
  },
  components: {
    MessageViewer
  },
  filters: {
    dateFormat(v) {
      return moment(v).format('DD-MM-YYYY HH:mm')
    }
  },
  mounted() {
    if (this.value.adminid && /^\d+$/.test(this.value.adminid)) this.getFbName(this.value.adminid)
  },
  computed: {
    adminName() {
      var vm = this
      if (vm.value.adminid) {
        if (/^\d+$/.test(vm.value.adminid)) {
          var result = vm.$store.state.facebook_users_name.find(el => el.id == vm.value.adminid)
          if (result) return result.name
        } else {
          return vm.value.adminid
        }
      } else return ''
    },
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    isReceiver: function() {
      // sender == admin and bot
      // receiver == customer
      return this.value.answerby == ''
    },
    parseAnswerMessage: function() {
      var vm = this
      var messages = [[]]
      var chatdetail = vm.message.messagedata
      var chattype = vm.message.messagetype

      if (chattype == 'template') {
        if (vm.message.intent == '{welcome}') {
          messages = [
            [
              {
                type: 'welcome_message'
              }
            ]
          ]
        } else {
          try {
            messages = [
              [
                {
                  type: 'generic',
                  data: JSON.parse(chatdetail),
                  ratio: vm.message.ratio == 'horizontal' ? 'horizontal' : 'square'
                }
              ]
            ]
          } catch (error) {
            messages = [
              [
                {
                  type: 'text',
                  text: chatdetail
                }
              ]
            ]
          }
        }
      } else if (chattype == 'text' && chatdetail.includes('{welcome_message}')) {
        messages = [
          [
            {
              type: 'welcome_message'
            }
          ]
        ]
      } else if (chattype == 'json' || chattype == 'replyinbox') {
        try {
          var message = JSON.parse(chatdetail)
          messages[0] = message
        } catch (error) {
          vm.isError = true
        }
      } else if (chattype == 'noreply' || chatdetail == '') {
        vm.$set(vm.message, 'messagetype', 'noreply')
      } else {
        var newGroup = []
        var group = chatdetail.split('||')
        $.each(group, function(index, messages) {
          var newMessage = []
          var group_messages = messages.split('#nl')
          $.each(group_messages, function(index, message) {
            var type = 'text'
            if (!isNaN(message)) {
              newMessage.push({
                type: 'text',
                text: message
              })
            } else if (vm.isJsonParseable(message)) {
              var messageParsed = JSON.parse(message)
              newMessage.push({
                text: messageParsed.text,
                buttons: messageParsed.buttons,
                type: 'button'
              })
            } /* else if (vm.isURL(message)) {
              newMessage.push({
                type: 'image',
                image_url: message
              })
            } */ else {
              newMessage.push({
                type: 'text',
                text: message
              })
            }
          })
          newGroup.push(newMessage)
        })
        messages = newGroup
      }

      return messages
    },
    parseQuestionMessage: function() {
      var vm = this
      var messages = [[]]
      var chatdetail = vm.message.questiondata
      var chattype = vm.message.questiontype

      if (chattype) {
        if (chattype == 'template') {
          if (vm.message.intent == '{welcome}') {
            messages = [
              [
                {
                  type: 'welcome_message'
                }
              ]
            ]
          } else {
            messages = [
              [
                {
                  type: 'generic',
                  data: JSON.parse(chatdetail),
                  ratio: vm.message.ratio == 'horizontal' ? 'horizontal' : 'square'
                }
              ]
            ]
          }
        } else if (chattype == 'json') {
          try {
            // messages = JSON.parse(chatdetail)
            var message = JSON.parse(chatdetail)
            messages[0] = message
          } catch (error) {
            vm.isError = true
          }
        } else if (chattype == 'noreply' || chatdetail == '') {
          vm.$set(vm.message, 'questiontype', 'noreply')
        } else if (chattype == 'image') {
          messages = [
            [
              {
                type: 'image',
                image_url: chatdetail
              }
            ]
          ]
        } else if (chattype == 'video') {
          if (vm.message.intent == '{video}') {
            messages = [
              [
                {
                  type: 'video',
                  video_url: chatdetail
                }
              ]
            ]
          }
        } else if (chattype == 'audio') {
          if (vm.message.intent == '{audio}') {
            messages = [
              [
                {
                  type: 'audio',
                  audio_url: chatdetail
                }
              ]
            ]
          }
        } else {
          var newGroup = []
          var group = chatdetail.split('||')
          $.each(group, function(index, messages) {
            var newMessage = []
            var group_messages = messages.split('#nl')
            $.each(group_messages, function(index, message) {
              var type = 'text'
              if (!isNaN(message)) {
                newMessage.push({
                  type: 'text',
                  text: message
                })
              } else if (vm.isJsonParseable(message)) {
                var messageParsed = JSON.parse(message)
                newMessage.push({
                  text: messageParsed.text,
                  buttons: messageParsed.buttons,
                  type: 'button'
                })
              } else {
                newMessage.push({
                  type: 'text',
                  text: message
                })
              }
              // else if (vm.isURL(message)) {
              //   newMessage.push({
              //     type: 'image',
              //     image_url: message
              //   })
              // }
            })
            newGroup.push(newMessage)
          })
          messages = newGroup
        }
      }
      return messages
    }
  },
  methods: {
    async getFbName(userid) {
      var vm = this
      var fbusersname = vm.$store.state.facebook_users_name
      if (!fbusersname.some(el => el.id == userid))
        var result = await axios.get(
          `https://graph.facebook.com/${userid}?fields=name&access_token=${
            vm.selectedBot.page_access_token
          }`
        )
      if (result) {
        vm.$store.state.facebook_users_name.push(result.data)
      }
    }
  },
  watch: {
    value: function(newVal, oldVal) {
      this.message = newVal
    }
  }
}
</script>

<style lang="scss" scoped>
.message-item {
  margin: 5px;
}
.receiver {
  white-space: nowrap;
  .user,
  .message {
    float: left;
  }

  .user {
    margin-right: 5px;
  }
}
.sender {
  white-space: nowrap;
  .user,
  .message {
    float: right;
  }

  .user {
    margin-left: 5px;
  }
}
.messageTime {
  position: absolute;
  bottom: -7px;
  font-size: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/livechat/livechat-message.vue